<template>
<div class="contrast" :style="{'margin-top': is_share ? '0' : '.3rem' }">
  <p class="title" v-if="cItem.hide_title == 0 && !is_share"><img :src="static_img_url + 'mobile/pic/tct_icon.png'" />{{cItem.title}}</p>
  <div class="contrast-summary" v-html="cItem.summary" v-if="!is_share"></div>
  <div style="position: relative; overflow: hidden; min-height: 1.2rem">
    <div style="width: 0; height: 0; overflow: hidden;">
      <div class="contrast-content" :id="'shareImg' + cItem.id" v-show="!imgbase">
        <div class="contrast-head">
          <div class="head-1">地区/分类</div>
          <div class="head-2">
            <div
              class="head-items"
              v-for="item,index in new_annotation_tag"
              :key="index"
              :ref="'head-items-' + item.id">
              <div class="chk">
                <span :style="{'border-color' : colors[index] || 'rgba(250, 122, 80, 1)'}">{{item.name}}<i class="iconfont">&#xe628;</i><i class="icon_bg" :style="{'border-bottom-color' : colors[index] || 'rgba(250, 122, 80, 1)'}"></i></span>
              </div>
              <div class="axis">
                <div
                  class="head-item"
                  v-for="item2,index2 in item.children"
                  :key="index2"
                >
                  <span>{{item2.name.length > 4 ? item2.name.substr(0, 3).concat('...') : item2.name}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="contrast-list">
          <div class="contrast-li" v-for="item in cItem.content.y" :key="item">
            <div class="label-tag">{{item | dealNeed(address)}}</div>
            <div class="label-data" v-for="item2,index2 in new_annotation_tag" :style="{'width': width_list[item2.id] + 'px'}">
              <div
                class="year-item"
                v-for="item3,index3 in item2.children"
                :key="index3"
              >
                <div class="data-item">
                  <span
                    v-for="item4 in cItem.content.res"
                    :style="{'width': '30px', 'background-color' : colors[index2] || 'rgba(250, 122, 80, 1)'}"
                    v-if="item4.address_id == item && item4.tag_id == item3.id"
                    @click="handleClickItem(item4)"
                    ></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <img :src="imgbase" :preview="cItem.id" v-show="imgbase" class="imgbase"/>
    <div class="loading_img" v-if="!imgbase">
      <div class="con"><span class="loader-box"></span><br><p>图片生成中</p></div>
    </div>
  </div>
  <div class="share-area" v-if="!is_share">
    <p>数据来源：{{cItem.src_name | empty('动脉橙产业智库')}}</p>
    <div class="right">
      <span>分享至</span>
      <div @click="handleClickShare">
        <i class="iconfont">&#xe641;</i>
      </div>
    </div>
  </div>

</div>
</template>
<script>
import html2canvas from 'html2canvas'
export default {
  props: ['cItem', 'uid', 'annotationTag', 'address'],
  data() {
    return {
      colors: ['#E96350','#FFCB6A','#A6D911','#36CFC9','#40A9FF','#F88C52','#FFCCBC','#53C419','#1EA69B','#2F54EB'],
      width_list: {},
      imgbase: ''
    }
  },
  computed: {
    list_show() {
      return function(i) {
        let index = this.list_show_index.findIndex((a) => a == i)
        if (index > -1) {
          return true
        } else {
          return false
        }
      }
    },
    static_img_url() {
      return this.$store.state.static_img_url
    },
    item_width() {
      return function(n) {
        if (n <= 5) {
          return '10px'
        } else if (n > 5 && n <= 10) {
          return '20px'
        } else if (n > 10) {
          return '30px'
        }
      }
    },
    new_annotation_tag() {
      let narr = [], arr = []
      this.cItem.content.x.map((a) => {
        let index = this.annotationTag.findIndex((b) => a == b.id)
        if (index > -1 && this.annotationTag[index].pid) {
          narr.push(this.annotationTag[index])
        }
      })
      narr.map((a) => {
        let index = this.annotationTag.findIndex((b) => b.id == a.pid)
        if (index > -1) {
          let index2 = arr.findIndex((b) => b.id == this.annotationTag[index].id)
          if (index2 == -1) {
            arr.push(Object.assign(this.annotationTag[index], {children: []}))
          }
        }
      })
      narr.map((a) => {
        let index = arr.findIndex((b) => a.pid == b.id)
        if (index > -1) {
          arr[index].children.push(a)
        }
      })
      arr = JSON.parse(JSON.stringify(arr))
      return arr
    },
    is_share() {
      return this.$route.name == 'MShareScatter' || this.$route.name == 'MShareScatterWx'
    }
  },
  methods: {
    changeWidth() {
      this.$nextTick(() => {
        this.new_annotation_tag.map((a) => {
          this.width_list[a.id] = this.$refs['head-items-' + a.id][0].offsetWidth
        })
        this.$forceUpdate()
        setTimeout(() => {
          html2canvas(document.getElementById('shareImg'+this.cItem.id),{ scale: 2}).then((canvas) => {
            let save_url= canvas.toDataURL("image/png")
            this.$set(this.$data, 'imgbase', save_url)
            if(this.is_share) {
              this.$emit('greatImg', true)
            }
            this.$previewRefresh()
          })
        }, 200)
      })
    },
    handleClickShare() {
      this.$router.push({name: 'MShareScatter', query: { tct_id: this.cItem.id,  theme_uid: this.uid}})
    }
  },
  mounted() {
    this.changeWidth()
  }
}
</script>
<style lang="stylus" scoped>
@import '~styles/common.stylus'
@import '~mobile/styles/shareLoading.stylus'
@import '~mobile/styles/constrast.stylus'
.contrast-li
  &:nth-of-type(odd)
    background: none !important
    > div
      background-color: #FFFAF6
.contrast-content
  position: relative
  width: auto
  display: inline-block
.contrast-head
  padding: 0
  min-width: auto
  .head-1
    padding-top: .84rem
    padding-left: .4rem
    width: 1.84rem
    flex: none
    align-items: flex-start
  .head-2
    flex: none
    margin-left: 0
    font-size: 0
    display: flex
    .head-items
      text-align: center
      padding: .08rem .2rem
      >>> .ivu-tooltip
        &-rel
          cursor: pointer
      &+.head-items
        border-left: 1px dashed #D5D5D5
      .chk
        margin-bottom: .16rem
        span
          font-size: .24rem
          display: inline-block
          line-height: 1
          color: #686868
          border: .02rem solid
          padding: .16rem .2rem
          position: relative
          i.iconfont
            position: absolute
            color: #fff
            font-size: .24rem
            bottom: -.06rem
            right: -.06rem
            z-index: 2
            transform: scale(.5, .5)
          .icon_bg
            content: ''
            position: absolute
            width: 0;
            height: 0;
            border-bottom: .24rem solid
            border-left: .24rem solid transparent
            bottom: 0
            right: 0
            z-index: 1
    .axis
      display: flex
      height: .44rem
      .head-item
        width: 1.2rem
        height: .44rem
        &:before
          bottom: 0
.contrast-li
  padding: 0
  min-width: auto
  .label-tag
    padding: .32rem
    width: 1.84rem
    flex: none
  .label-data
    flex: none
    margin-left: 0
    font-size: 0
    padding: .32rem .2rem
    &+.label-data
      border-left: 1px dashed #D5D5D5
  .year-item
    width: 1.2rem
</style>
